module.exports = __webpack_public_path__ + "static/codebase-5a6a7ea703bab9af51ccc8e8d632c230.png";